import React, { useEffect, useState } from "react";
import "./styles.css";
import "bootstrap/dist/css/bootstrap.css";
import "../assets/css/loader.css";

function ContantLoaderPage(props) {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <div className="loader-wrapper" style={{ width: "100%", height: "100%" }}>
        <div className="content-loader">
          <div className="sp sp-wave"></div>
        </div>
      </div>
    </div>
  );
}
export default ContantLoaderPage;
